import React from 'react'

const AccommodationIcon: React.FC = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
		<path
			className="stroke-current"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2"
			d="M7 10l2 2 4-4M5.836 2.697a3.42 3.42 0 001.947-.807 3.42 3.42 0 014.437 0 3.42 3.42 0 001.947.807 3.42 3.42 0 013.138 3.137 3.42 3.42 0 00.806 1.947 3.42 3.42 0 010 4.437 3.42 3.42 0 00-.806 1.947 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.947.806 3.42 3.42 0 01-4.437 0 3.42 3.42 0 00-1.947-.806 3.42 3.42 0 01-3.137-3.138 3.42 3.42 0 00-.807-1.947 3.42 3.42 0 010-4.437 3.42 3.42 0 00.807-1.947 3.42 3.42 0 013.137-3.137z"
		></path>
	</svg>
)

export default AccommodationIcon
